const sanitizePickerValue = (value, fallback) => {
  if (!value || typeof value !== "string") return fallback;
  const trimmed = value.trim();
  const gradientMatch = trimmed.match(
    /(linear-gradient|radial-gradient|conic-gradient)\s*\([^]*?\)(?=\s*(,|$))/i
  );
  if (gradientMatch) return gradientMatch[0];
  if (/url\s*\(/i.test(trimmed)) return fallback;
  return trimmed;
};

export default sanitizePickerValue;
